class DualImageGallery {
  constructor(mediaGalleryElement) {
    this.mediaGallery = mediaGalleryElement;
    this.thumbnailButtons = this.mediaGallery.querySelectorAll('.product__thumbnail-button');
    this.galleryId = this.getGalleryId();
    this.primarySlider = this.mediaGallery.querySelector('#GalleryViewer-Primary-' + this.galleryId);
    this.secondarySlider = this.mediaGallery.querySelector('#GalleryViewer-Secondary-' + this.galleryId);
    
    this.init();
  }

  getGalleryId() {
    const id = this.mediaGallery.getAttribute('id');
    return id.replace('MediaGallery-', '');
  }

  init() {
    if (!this.thumbnailButtons.length) return;

    // Initialize with first thumbnail selected (images 1 & 2)
    this.selectThumbnail(0);

    this.thumbnailButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.selectThumbnail(index));
    });
  }

  selectThumbnail(index) {
    // Update thumbnail active state
    this.thumbnailButtons.forEach((btn) => {
      btn.closest('.product__thumbnail-item').classList.remove('is-active');
    });
    this.thumbnailButtons[index].closest('.product__thumbnail-item').classList.add('is-active');

    // Update primary image to selected index
    this.updateSliderToIndex(this.primarySlider, index);
    
    // Update secondary image to next index (index + 1)
    const secondaryIndex = index + 1;
    this.updateSliderToIndex(this.secondarySlider, secondaryIndex);
  }

  updateSliderToIndex(sliderContainer, index) {
    if (!sliderContainer) return;

    const slides = sliderContainer.querySelectorAll('.product__media-item');
    slides.forEach((slide) => slide.classList.remove('is-active'));
    
    if (slides[index]) {
      slides[index].classList.add('is-active');
    }
  }
}

// Initialize when element is defined
customElements.whenDefined('media-gallery').then(() => {
  document.querySelectorAll('.media-gallery--dual-view').forEach((gallery) => {
    new DualImageGallery(gallery);
  });
});
